import { PageModel } from "../models";

export function isPageModel(value: unknown): value is PageModel {
    return (value as PageModel)?.type === "page";
}
export function assertIsPageModel(value: unknown): asserts value is PageModel {
    if (!isPageModel(value)) {
        throw new TypeError(`Value is not of type PageModel: ${value}`);
    }
}
